import { _IsAS } from './common';
/**
 * 提供原生方法唤起统一方法接口
 * @param iosMethod: ios原生方法
 * @param androidMethod: android原生方法
 * @param param: 传递参数(字符串，原生不接受number和object)
 */

const methodInvoke = (iosMethod: string, androidMethod: string, param: any, callback?: () => void) => {
  if (_IsAS() === 1) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[iosMethod]) {
      window.webkit.messageHandlers[iosMethod].postMessage(param);
    } else {
      callback && callback();
    }
  } else if (_IsAS() === 2) {
    if (window.android && window.android[androidMethod]) {
      window.android[androidMethod](param);
    } else {
      callback && callback();
    }
  } else if (_IsAS() === 3) {
    if (window.harmony && window.harmony[androidMethod]) {
      window.harmony[androidMethod](param);
    } else {
      callback && callback();
    }
  }
};
/**
 * webview app内跳转
 * @param href: 跳转地址
 */
let routerToNativePage = (href: string) => {
  methodInvoke('routerAppUrl', 'routerAppUrl', href);
};
/**
 * app内原生页面跳转
 * @param href: 跳转地址
 */
let routerToPage = (href: string) => {
  methodInvoke('routerAppUrl', 'routerAppUrl', href);
};
/**
 * 复制
 * @param copyStr: 复制内容
 */
let copyAction = (copyStr: string) => {
  methodInvoke('copyAction', 'copyAction', copyStr);
};

/**
 * 返回app上一级
 * @param status: 1 直接返回上一级 空字符串为原有逻辑
 */
let callAppBack = (status = '') => {
  methodInvoke('NavBackAction', 'navBackAction', status);
};
/**
 * 分享方法，这个会弹窗
 * @param shareStr: 分享对象序列化成的字符串
 * @param title: 分享标题
 * @param detail: 分享的介绍
 * @param url: 分享链接
 * @param thumbUrl:分享简介图片链接
 * @param shareType: 分享渠道
 * @param contentType:分享方式  1链接的形式 2图片
 */
let callShareObject = (shareStr: string) => {
  methodInvoke('ShareModel', 'callShareObject', shareStr);
};

// 参数同上 ,这个不会弹窗
const callShareJump = (params: string) => {
  methodInvoke('callShareInvitationCode', 'callShareInvitationCode', params);
};
/**
 * 调用商城tips
 * @param type: 1 满分礼盒 2商品详情
 */
let callShareGuide = (type: any) => {
  //1 满分礼盒  2商品详情页
  methodInvoke('callShareGuide', 'callShareGuide', type);
};
/**
 * 上传图片
 * @param apiStr: 序列化的对象字符串
 * @param url: 接口地址
 * @param param: 要传的参数
 */
let callUploadImg = (apiStr: string) => {
  //上传的接口地址
  methodInvoke('callUploadImg', 'callUploadImg', apiStr);
};
let callUploadImgNoCrop = (apiStr: string) => {
  //上传的接口地址
  methodInvoke('callUploadImgNoCrop', 'callUploadImgNoCrop', apiStr);
};

let callReady = (str: any) => {
  //ios没有这个方法，通知安卓，页面加载完成
  // str 0 代表编辑器  1代表兴趣标签  2代表会员权益H5 3会员开通页详情
  methodInvoke('callReady', 'callReady', str);
};

let callShowPictures = (dataStr: any) => {
  methodInvoke('callViewPictures', 'callLookAllForMall', dataStr);
};

let callShowTopNavigation = ({ close = 0, refresh = 0, share = 0, hidden = 0 }: any) => {
  // close 是否隐藏顶部栏的关闭按钮 0 隐藏  1显示
  // refresh 是否隐藏顶部栏的刷新按钮 0 隐藏 1 显示
  // share 是否隐藏顶部栏分享按钮 0 隐藏 1 显示
  // hideen 是否隐藏顶部栏 1 隐藏 0 显示
  methodInvoke('callShowTopNavigation', 'callShowTopNavigation', JSON.stringify({ close, refresh, share, hidden }));
};

/**
 * 是否允许分享
 * @param isShare: 是否分享：'1':不是 '0':是
 */
let limitShare = (isShare: string) => methodInvoke('LimitShareModel', 'callLimitShare', isShare);
/**
 * 调用登陆
 * @param isLogin: 是否登陆：1:不是 0:是
 */
let callLogin = (isLogin: any) => methodInvoke('LoginModel', 'callLogin', isLogin);
/**
 * 调用原生toast
 * @param data message: 要显示的字符串  type: info 普通  fail 错误  success 成功
 */
let callToastAction = (data: any) => methodInvoke('callToastAction', 'callToastAction', _IsAS() === 1 ? data : data.message);
/**
 * 选中兴趣标签
 * @param data 选中的tagId
 */
let callUpdateSelectTags = (data: any) => methodInvoke('callUpdateSelectTags', 'callUpdateSelectTags', data);
/**
 * 调用音频播放
 * @param 音频播放
 */
let audioPlay = (status?: any) => methodInvoke('AudioPlayAction', 'audioPlayAction', status);
/**
 * 调用收藏
 * @param 收藏
 */
let CallCollectBox = (data: any) => methodInvoke('WritingCollectAction', 'writingCollectAction', data);
/**
 * 调用练笔
 * @param 练笔
 */
let WritingDetailAction = (id: any) => methodInvoke('WritingDetailAction', 'writingDetailAction', id);
/**
 * 调用练笔分享
 * @param 练笔
 */
let WritingShareActionBox = (data: any) => methodInvoke('WritingShareAction', 'practiceShare', data);
/**
 * 通知移动端页面高度
 * @param height 页面高度
 */
let callUpdateContentHeight = (height: any) => methodInvoke('callUpdateContentHeight', 'callUpdateContentHeight', height);
//跳转微信小程序
let callWechatApplet = (pathStr: any) => {
  // let pathStr = {
  //   path:wxpath,
  //   id:wxid
  // }
  methodInvoke('callWechatApplet', 'callWechatApplet', pathStr);
};
//范文注释弹框
let callMonthlyModel = (dataStr: any) => {
  methodInvoke('callMonthlyModel', 'callMonthlyModel', dataStr);
};

/**
 * 通知移动端保存选择内容为笔记
 * @param selection 选择文本
 */
const callSaveNote = (selection: string) => {
  methodInvoke('callSaveNote', 'callSaveNote', selection);
};
/**
 * 通知移动端分享选择内容
 * @param selection 选择文本
 */
const callShareNote = (selection: string) => {
  methodInvoke('callShareNote', 'callShareNote', selection);
};

/**
 * 通知移动端考试已提交
 * @param courseDataId 课程内容ID
 */
const callSubmitAnswerSheet = (courseDataId: string) => {
  methodInvoke('callSubmitAnswerSheet', 'callSubmitAnswerSheet', courseDataId);
};

/**
 * 禁用弹簧效果
 * @param state 状态 false禁用 true启用
 */
const callSetBounces = (state: boolean) => {
  methodInvoke('callSetBounces', 'callSetBounces', state);
};

/**
 * 通知移动端滚动到指定高度
 * @param top
 */
const callLocationContentHeight = (top: number) => {
  methodInvoke('callLocationContentHeight', 'callLocationContentHeight', top);
};

/**
 * 跳转日更第一条长纸条
 * @param type
 */
const callExecuteTask = (type: number) => {
  methodInvoke('callExecuteTask', 'callExecuteTask', JSON.stringify({ type }));
};

const callBrilliantWriting = (content: string) => {
  methodInvoke('callBrilliantWriting', 'callBrilliantWriting', content);
};

const callDownloadImage = (url: string) => {
  methodInvoke('callSaveImage', 'callSaveImage', url); // 安卓未实现该方法
};

const callAiGeneratedImage = (content: string) => {
  methodInvoke('callAiGeneratedImage', 'callAiGeneratedImage', content);
};

export default {
  routerToNativePage,
  routerToPage,
  copyAction,
  callAppBack,
  callShareObject,
  callShareJump,
  callShareGuide,
  callUploadImg,
  callUploadImgNoCrop,
  callReady,
  callShowPictures,
  callShowTopNavigation,
  limitShare,
  callLogin,
  callToastAction,
  callUpdateSelectTags,
  audioPlay,
  CallCollectBox,
  WritingDetailAction,
  WritingShareActionBox,
  callUpdateContentHeight,
  callWechatApplet,
  callMonthlyModel,
  callSaveNote,
  callShareNote,
  callSubmitAnswerSheet,
  callSetBounces,
  callLocationContentHeight,
  callExecuteTask,
  callBrilliantWriting,
  callDownloadImage,
  callAiGeneratedImage
};
